// PieChart.js
import React from "react";
import Chart from "react-apexcharts";
import "./../../styles/App.css";

const PieChart = ({ data }) => {
  const options = {
    chart: {
      type: "pie",
      height: 400,
    },
    title: {
      text: "",
    },
    legend: {
      position: "bottom",
    },
    labels: data.labels,
    dataLabels: {
      style: {
        fontSize: "18px", // Increased from 12px to 18px for better readability
        fontWeight: "bold",
        color: "#ffffff", // White text for better contrast
      },
      dropShadow: {
        enabled: true, // Enable shadow for better text visibility
        top: 1,
        left: 1,
        blur: 2,
        opacity: 0.7,
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -10,
        },
      },
    },
  };

  const series = data.values;

  return (
    // 340px
    <div
      className="pie-chart-container"
      style={{ maxWidth: "40vw", height: "320px" }}
    >
      <Chart options={options} series={series} type="pie" height={320} />
    </div>
  );
};

export default PieChart;